export enum BootstrapBreakpoints {
    XSmall = '(max-width: 575.98px)',
    Small = '(min-width: 576px)',
    Medium = '(min-width: 768px)',
    Large = '(min-width: 992px)',
    XLarge = '(min-width: 1200px)',
    XXLarge = '(min-width: 1600px)',
}
